// import { Component, OnInit } from '@angular/core';
// import { homeConst } from '../../constants';

// @Component({
//     selector: 'app-home-demo-one',
//     templateUrl: './home-demo-one.component.html',
//     styleUrls: ['./home-demo-one.component.scss'],
// })
// export class HomeDemoOneComponent implements OnInit {
//     formValues = homeConst;

//     constructor() {}

//     ngOnInit(): void {}
// }

import {
    AfterViewInit,
    Component,
    ElementRef,
    HostListener,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';

import { homeConst } from '../../constants';

@Component({
    selector: 'app-home-demo-one',
    templateUrl: './home-demo-one.component.html',
    styleUrls: ['./home-demo-one.component.scss'],
})
export class HomeDemoOneComponent
    implements OnInit, AfterViewInit, OnDestroy {

    formValues = homeConst;

    // =========================================
    // EXISTING HOME FUNCTIONALITY
    // =========================================

    scrollProgress = 0;

    showMobileCta = false;

    videoPlaying = false;


    // =========================================
    // VIDEO
    // =========================================

    @ViewChild('explainerVideo')
    explainerVideo?: ElementRef<HTMLVideoElement>;


    // =========================================
    // SCROLL REVEAL
    // =========================================

    private observer?: IntersectionObserver;

    private revealElements: HTMLElement[] = [];


    constructor(
        private hostElement: ElementRef<HTMLElement>
    ) { }


    // =========================================
    // ANGULAR LIFECYCLE
    // =========================================

    ngOnInit(): void {
        // Nothing required here
    }


    ngAfterViewInit(): void {

        // Update scroll progress + mobile CTA
        this.updateScrollState();

        // Initialize reveal animation
        this.initScrollReveal();

    }


    ngOnDestroy(): void {

        // Disconnect IntersectionObserver
        if (this.observer) {
            this.observer.disconnect();
        }

        // Clear reference
        this.revealElements = [];

    }


    // =========================================
    // WINDOW SCROLL
    // =========================================

    @HostListener('window:scroll')
    onWindowScroll(): void {

        this.updateScrollState();

    }


    // =========================================
    // SCROLL STATE
    // =========================================

    private updateScrollState(): void {

        const scrollTop =
            window.scrollY ||
            document.documentElement.scrollTop ||
            0;


        const documentHeight =
            document.documentElement.scrollHeight -
            window.innerHeight;


        // =====================================
        // SCROLL PROGRESS
        // =====================================

        if (documentHeight > 0) {

            this.scrollProgress =
                Math.min(
                    Math.max(
                        scrollTop / documentHeight,
                        0
                    ),
                    1
                );

        } else {

            this.scrollProgress = 0;

        }


        // =====================================
        // MOBILE CTA
        // =====================================

        this.showMobileCta =
            window.innerWidth <= 720 &&
            scrollTop > 300;

    }


    // =========================================
    // MOBILE / SECTION NAVIGATION
    // =========================================

    mobileSectionClick(section: string): void {

        const element = document.getElementById(section);

        if (!element) {
            return;
        }

        element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }


    // =========================================
    // SCROLL REVEAL
    // =========================================
    //
    // Behavior:
    //
    // Initial:
    // opacity: 0
    // translateY(40px)
    //
    // When entering viewport:
    // opacity: 1
    // translateY(0)
    //
    // After reveal:
    // element is unobserved
    //
    // Therefore:
    //
    // Scroll DOWN  -> animation plays
    // Scroll UP    -> stays visible
    //
    // =========================================

    private initScrollReveal(): void {

        // =====================================
        // CHECK BROWSER SUPPORT
        // =====================================

        if (
            typeof window === 'undefined' ||
            typeof IntersectionObserver === 'undefined'
        ) {
            return;
        }


        // =====================================
        // GET ELEMENTS ONLY FROM THIS COMPONENT
        // =====================================

        const host =
            this.hostElement.nativeElement;


        const elements =
            Array.from(
                host.querySelectorAll<HTMLElement>(
                    '[data-reveal]'
                )
            );


        // Nothing to animate
        if (!elements.length) {
            return;
        }


        this.revealElements = elements;


        // =====================================
        // INITIAL STATE
        // =====================================

        elements.forEach((element) => {

            // Remove any old state
            element.classList.remove(
                'reveal-visible'
            );

            // Add hidden state
            element.classList.add(
                'reveal-hidden'
            );


            // Read delay
            const delay =
                element.getAttribute(
                    'data-reveal-delay'
                );


            if (delay) {

                const delayNumber =
                    parseInt(delay, 10);


                if (!Number.isNaN(delayNumber)) {

                    element.style.setProperty(
                        '--reveal-delay',
                        `${delayNumber}ms`
                    );

                }

            }

        });


        // =====================================
        // INTERSECTION OBSERVER
        // =====================================

        this.observer =
            new IntersectionObserver(

                (entries) => {

                    entries.forEach((entry) => {

                        if (!entry.isIntersecting) {
                            return;
                        }


                        const element =
                            entry.target as HTMLElement;


                        // =================================
                        // REVEAL
                        // =================================

                        element.classList.remove(
                            'reveal-hidden'
                        );


                        element.classList.add(
                            'reveal-visible'
                        );


                        // =================================
                        // STOP OBSERVING
                        // =================================
                        //
                        // This is important.
                        //
                        // The animation will NOT replay
                        // when scrolling back up.
                        //
                        // =================================

                        this.observer?.unobserve(
                            element
                        );

                    });

                },

                {
                    threshold: 0.15,

                    rootMargin:
                        '0px 0px -50px 0px'
                }

            );


        // =====================================
        // START OBSERVING
        // =====================================

        elements.forEach((element) => {

            this.observer?.observe(
                element
            );

        });

    }


    // =========================================
    // VIDEO
    // =========================================

    playVideo(): void {

        const video =
            this.explainerVideo?.nativeElement;


        if (!video) {
            return;
        }


        // =====================================
        // PLAY
        // =====================================

        if (video.paused) {

            video.play()
                .then(() => {

                    this.videoPlaying = true;

                })
                .catch(() => {

                    this.videoPlaying = false;

                });

        }


        // =====================================
        // PAUSE
        // =====================================

        else {

            video.pause();

            this.videoPlaying = false;

        }

    }

}